module.exports = __webpack_public_path__ + "static/media/document-text.bdeff969.svg";